module.exports = __webpack_public_path__ + "static/img/bg-en.71a17a9d.png";